/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountPlanOccurrence } from './accountPlanOccurrence';
import { AccountPlanType } from './accountPlanType';


export interface AccountPlanConfig { 
    planId: number;
    plan: AccountPlanType;
    occurrence: AccountPlanOccurrence;
    price: number;
    tenantId?: number | null;
    description: string;
    maxEmployees: number;
}
export namespace AccountPlanConfig {
}


